var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgK4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.58 22.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-K4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,22.57c.5-.09,4.71-1.47,5.65-1.78.67-.21.49-.12,1.08.17a11.42,11.42,0,0,0,11.65-1.33A11,11,0,0,0,20.62,4.76,11.16,11.16,0,0,0,10.42.05,11,11,0,0,0,1.57,16c.47,1,.53.36-.07,2.14-.13.41-1.44,4.18-1.5,4.48Zm2.79-2.73c.47-.07,2.09-.66,2.79-.86.29-.08.66-.31,1-.15A9.26,9.26,0,0,0,18,4.35a9.38,9.38,0,0,0-7.17-2.57A9.1,9.1,0,0,0,7,2.91,9.8,9.8,0,0,0,4.87,4.5,9.65,9.65,0,0,0,2.56,8.33a9.17,9.17,0,0,0,1.21,7.85c.25.37.1.47,0,.91s-.21.6-.32.92c-.2.62-.45,1.24-.62,1.84ZM7.41,6.06A2.72,2.72,0,0,0,6.18,7.75C5.6,9.89,7.7,12.16,9,13.54a8.82,8.82,0,0,0,3.63,2.19,4.07,4.07,0,0,0,2.38.38,2.28,2.28,0,0,0,2.09-2.36c0-.4-.47-.5-.8-.66s-1.75-1-2.09-.76c-.07.05-.52.65-.66.8s-.36.67-.9.47a7.59,7.59,0,0,1-1.88-1.08c-.45-.34-2-1.92-1.87-2.47,0-.14.55-.66.65-.82.42-.61.09-1-.39-2.11a7.15,7.15,0,0,0-.46-1c-.18-.23-1-.22-1.3-.09Z",
    transform: "translate(0 -0.01)",
    fill: "#26d466",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgK4);
export default __webpack_public_path__ + "static/media/K4.581828307678a18b08e187bc09a9bb22.svg";
export { ForwardRef as ReactComponent };